export const PER_PAGE = 20;
export const DESCRIPTION_TRUNCATE_LEN = 60;

export function promptTemplateEditPath(slug) {
  return `/prompt-templates/${encodeURIComponent(slug)}/edit`;
}

export function formatDate(iso) {
  if (!iso) return '—';
  return new Intl.DateTimeFormat('pt-BR', {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(new Date(iso));
}

export function truncateText(text, maxLen = 80) {
  if (!text) return '—';
  if (text.length <= maxLen) return text;
  return `${text.slice(0, maxLen).trim()}…`;
}
